<template>
    <div>
        <div class="action-table-web" v-if="$detect == 'web'">
            <div class="row">
                <div class="col-3">
                    <div class="row">
                        <div class="col">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px"
                                placeholder="Mã đơn hàng..."
                                 v-model="data.keyword_code"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px"
                                placeholder="Tên khách hàng..."
                                 v-model="data.keyword_name"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px"
                                placeholder="Số điện thoại..."
                                v-model="data.keyword_phone"/>
                            </div>
                            <div class="text-danger fs-12px mt-1" v-if="error.keyword_phone">{{error.keyword_phone}}</div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col">
                            <div class="search position-relative">
                                <input type="text" class="w-100 bg-white fs-14px"
                                placeholder="Email..."
                                 v-model="data.keyword_email"/>
                            </div>
                            <div class="text-danger fs-12px mt-1" v-if="error.keyword_email">{{error.keyword_email}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-2">
                <div class="col-3 position-relative" >
                    <input class="form-control pl-35" type="date" placeholder="Từ" v-model="data.ord_date_start" id="example-date-input">
                    <span class="position-absolute tu">Từ : </span>
                </div>
                <div class="col-3 position-relative" >
                    <input class="form-control pl-45" type="date" placeholder="Từ" v-model="data.ord_date_end" id="example-date-input">
                    <span class="position-absolute den">Đến : </span>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col-12">
                            <ldc-select
                                placeholder="Trạng thái"
                                v-model="data.status"
                                >
                                <ldc-option
                                    v-for="(data, index) in arrStatusOrder" :key="index"
                                    :value="index"
                                    :label="data.title+' ('+arrTotalAll[index]+')'"/>
                            </ldc-select>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col-6">
                            <button class="btn btn-block border-0 fs-14px bg-primary text-white" style="height: 35px;" @click="emitModel()">Tìm kiếm</button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-block border-0 fs-14px btn-cancel-filter" style="height: 35px;" @click="removeFillter()">Bỏ lọc</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div class="action-table-mobile">
                <div class="d-flex mb-10px">
                    <div class="w-100 pl-1">
                        <button type="button" class="btn btn-primary time-date btn-block bg-white fs-14px pl-10px"
                            @click="fillterMobile = true">
                            <i class="icon ion-ios-options fs-18px mr-2"></i>Lọc nâng cao
                        </button>
                    </div>
                </div>
            </div>
            <ldc-model-mobile
                titileCancel="Hủy"
                :showCancel="false"
                :showTitle="true"
                title="Lọc đơn hàng"
                :customButton="true"
                :visible.sync="fillterMobile">
                <div slot="content-model"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    
                    <div class="item-fillter" role="button">
                        <ldc-select-mobile
                            placeholder="Trạng thái đơn hàng"
                            title="Trạng thái"
                            v-model="data.status"
                            >
                            <ldc-option-mobile
                                v-for="(data, index) in arrStatusOrder" :key="index"
                                :value="index"
                                :label="data.title"/>
                        </ldc-select-mobile>
                    </div>
                    <div class="search d-flex item-fillter">
                        <div class="w-48 pl-3 text-left">
                            Từ :
                        </div>
                        <div class="w-52">
                            <input class="form-control pr-4 border-0" type="date" placeholder="Từ" v-model="data.ord_date_start" id="example-date-input">
                        </div>
                    </div>
                    <div class="search d-flex item-fillter">
                        <div class="w-48 pl-3 text-left">
                            Đến :
                        </div>
                        <div class="w-52">
                            <input class="form-control pr-4 border-0" type="date" placeholder="Đến" v-model="data.ord_date_end" id="example-date-input">
                        </div>
                    </div>
                    <div class="search d-flex item-fillter">
                        <div class="w-50 pl-3 text-left">
                            Mã đơn hàng :
                        </div>
                        <div class="w-50">
                            <input type="text" class="w-100 bg-white fs-14px border-0 pr-4 text-right"
                                placeholder="Mã đơn hàng..."
                                 v-model="data.keyword_code"/>
                        </div>
                    </div>
                    <div class="search d-flex item-fillter">
                        <div class="w-50 pl-3 text-left">
                            Tên khách hàng :
                        </div>
                        <div class="w-50">
                            <input type="text" class="w-100 bg-white fs-14px border-0 pr-4 text-right"
                                placeholder="Tên khách hàng..."
                                 v-model="data.keyword_name"/>
                        </div>
                    </div>
                    <div class="search d-flex item-fillter">
                        <div class="w-50 pl-3 text-left">
                            Số điện thoại :
                        </div>
                        <div class="w-50">
                            <input type="text" class="w-100 bg-white fs-14px border-0 pr-4 text-right"
                                placeholder="Số điện thoại..."
                                v-model="data.keyword_phone"/>
                        </div>
                    </div>
                    <div class="search d-flex item-fillter">
                        <div class="w-50 pl-3 text-left">
                            Email :
                        </div>
                        <div class="w-50">
                            <input type="text" class="w-100 bg-white fs-14px border-0 pr-4 text-right"
                                placeholder="Email..."
                                 v-model="data.keyword_email"/>
                        </div>
                    </div>

                </div>
                <div slot="custom-buttom"
                    :class="{
                        'fillter-android': $isAndroid,
                        'fillter-ios': !$isAndroid,
                    }">
                    <div :class="{
                        'btn-confirm-android': $isAndroid,
                        'btn-confirm-ios mb-10px': !$isAndroid
                        }">
                        <button class="btn btn-primary radius-ios text-uppercase mr-10px fs-14px btn-apply"
                            @click="emitModel()" close-model-mobile>áp dụng</button>
                        <button class="btn btn-light radius-ios text-uppercase ml-10px fs-14px btn-cancel"
                            @click="removeFillter()" close-model-mobile>Bỏ lọc</button>
                    </div>
                </div>
            </ldc-model-mobile>
        </div>
    </div>
</template>

<script>
export default {
    props: ['value', 'idSelect','arrPromotionStatus', 'arrStatusOrder','arrTotalAll'],
    data() {
        return {
            loading: false,
            ord_date_start : '',
            ord_date_end : '',
            data: {
                keyword_code: '',
                status: -2,
                keyword_name: '',
                keyword_phone: '',
                keyword_email: '',
                ord_date_start : '',
                ord_date_end : '',
            },
            fillterMobile: false,
            error : [],
        }
    },
    watch: {
        value: {
            handler(val){
                this.data = val;
            },
            deep: true,
        },
        'data.keyword_phone'(val){
            let vnf_regex = /((09|03|07|08|05)+([0-9]{8})\b)/g;
            if(val !==''){
                if (vnf_regex.test(val) == false) 
                {   
                    this.error.keyword_phone = 'Số điện thoại của bạn không đúng định dạng!';
                   
                }else{
                    this.error.keyword_phone = '';
                }
            }else{
                this.error.keyword_phone = '';
            }
        },
        'data.keyword_email'(val){
            let email_regex = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if(val !==''){
                if (!email_regex.test(val)) 
                {   
                    this.error.keyword_email = 'Hãy nhập địa chỉ email hợp lệ.\nExample@gmail.com';
                   
                }else{
                    this.error.keyword_email = '';
                }
            }else{
                this.error.keyword_email = '';
            }
        }
    },
    created(){
       
    },
    methods: {
        emitModel(){
            if(this.error.length == 0 || this.error.keyword_email == '' && this.error.keyword_phone == ''){
                this.$emit('input', {
                    keyword_code: this.data.keyword_code,
                    status: this.data.status,
                    keyword_name: this.data.keyword_name,
                    keyword_phone: this.data.keyword_phone,
                    keyword_email: this.data.keyword_email,
                    ord_date_start : this.data.ord_date_start,
                    ord_date_end : this.data.ord_date_end
                })
            }
          
        },
        enterKeyword(){
            this.emitModel();
        },
        removeFillter(){
            this.data = {
                keyword_code: '',
                status: -2,
                keyword_name: '',
                keyword_phone: '',
                keyword_email: '',
                ord_date_start: '',
                ord_date_end: '',
            };
            this.emitModel();
        },
    }
}
</script>

<style lang="scss">
.ldc-model-mobile .slot-ios{
    line-height: 43px !important;
}
.pl-35{
    padding-left: 35px;
}
.pl-45{
    padding-left: 45px;
}
.tu, .den{
    top: 7px;
    left: 20px;
}

.ldc-model-mobile {
    .value-select-mobile {
        text-align: right;
    }
}
.w-52{
    width : 52%;
}
.w-48{
    width : 48%;
}
</style>
